import React, { FC, useEffect, useState } from "react";
import CommonMenuListPage from "../../../components/CustomMenuListPage/CommonMenuListPage";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import RaiseABug from "../RaiseABug/RaiseABug";
import CallUsPopUp from "../CallUsPopUp/CallUsPopUp";
import EmailUsPopUp from "../EmailUsPopUp/EmailUsPopUp";
import { useAppSelector } from "../../../redux-store/CustomReduxHooks";
import CustomChatWithUs from "../../../components/CustomChatWithUs/CustomChatWithUs";
import { CleverTapEventType } from "../../../utils/CleverTapConstant";
import { CT_ScreenEvntDtls } from "../../Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import { GTAScreenType, SCREEN_TYPE } from "../../../utils/constants";
import { triggerCleverTapEvent } from "../../../utils/CleverTap";
import { useNavigate, useSearchParams } from "react-router-dom";
import TriggerGTAEvent from "../../../utils/GTA";
import { useAppTranslation } from "../../../hooks/useAppTranslation";

interface Props {
  handleBackBtnClick: Function;
  pathname?: string;
  setVisibleComponent: Function;
}

const HelpAndSupport: FC<Props> = ({
  handleBackBtnClick,
  pathname,
  setVisibleComponent,
}) => {
  const { t } = useAppTranslation("common");
  const navigate = useNavigate();
  const [showRaiseABug, setShowRaiseABug] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [emailPopupOpen, setEmailPopupOpen] = useState<boolean>(false);
  const [showChatWithUs, setShowChatWithUs] = useState(false);
  const profileHamburgerMenuData = useAppSelector(
    (state) => state.GeneralAppElementsSlice.quickActionMenu,
  );
  const [URLSearchParam] = useSearchParams();
  const action = URLSearchParam.get("action") || "";
  const module = URLSearchParam.get("module") || "";
  const settingSubMenu = profileHamburgerMenuData?.[111]?.find(
    (i) => i.pathName === "help-&-support",
  )?.menuDetails;

  useEffect(() => {
    if (action === "helpAndSupport") {
      if (module === "reportABug") {
        setShowRaiseABug(true);
      } else if (module === "callUs") {
        setOpen(true);
      } else if (module === "emailUs") {
        setEmailPopupOpen(true);
      } else if (module === "chatWithUs") {
        setShowChatWithUs(true);
      } else if (module === "FAQs") {
        setVisibleComponent("FAQs");
      }
    }
  }, []);

  const handleCloseChat = () => {
    setShowChatWithUs(false);
  };

  const handleCleverTapCTAClick = (item: string) => {
    triggerCleverTapEvent("serv_help_&_support_option_click", {
      ScreenName: "Servicing Help And Support Option Selection Screen",
      ScreenType: SCREEN_TYPE.generalAppType,
      isPrevPageNameRequired: true,
      ctaText: item,
    });
  };
  const handleGTMCTAClick = (item: string) => {
    TriggerGTAEvent("serv_help_&_support_option_click", {
      screen_type: GTAScreenType.DashboardScreenType,
      screen_name: "servicing_help_and_support_option_selection_screen",
      CTA_text: item,
    });
  };

  const handleClick = (pathnameData: string) => {
    handleCleverTapCTAClick(pathnameData);
    handleGTMCTAClick(pathnameData);
    if (pathnameData === "report-bug") {
      setShowRaiseABug(true);
    } else if (pathnameData === "email") {
      // const recipientEmail = "care.digital@adityabirlacapital.com";
      // const subject = "Subject of the email";
      // const body = "Body of the email";
      // const mailtoUrl = `mailto:${recipientEmail}?subject=${encodeURIComponent(
      //   subject
      // )}&body=${encodeURIComponent(body)}`;
      // windowOpen(mailtoUrl, "_blank");
      setEmailPopupOpen(true);
    } else if (pathnameData === "call-us") {
      setOpen(true);
    } else if (pathnameData === "chat-with-us") {
      setShowChatWithUs(true);
    } else if (pathnameData === "FAQs") {
      setVisibleComponent(pathnameData);
    }
  };

  useEffect(() => {
    triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
      ScreenName: CT_ScreenEvntDtls.R_GAE.gaHelpSupportOptSelection.screenName,
      ScreenType: SCREEN_TYPE.DashboardScreenType,
    });
  }, []);

  return (
    <>
      <CommonMenuListPage
        title={t("hamburgerMenu.menuItems.helpSupport")}
        handleBackBtnClick={handleBackBtnClick}
        pathname={pathname}
      >
        <Box>
          {settingSubMenu ? (
            settingSubMenu
              .filter((item) => item.menuId)
              .map((item) => (
                <React.Fragment key={item.menuDisplayName}>
                  <ListItem
                    key={item.menuDisplayName}
                    onClick={() => handleClick(item.pathName || "")}
                    secondaryAction={
                      <IconButton
                        sx={{ marginRight: 0 }}
                        edge="end"
                        aria-label="delete"
                      >
                        <KeyboardArrowRightIcon />
                      </IconButton>
                    }
                    sx={{
                      marginY: ".625rem",
                      paddingLeft: "1.5rem",
                      cursor: "pointer",
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar src={item.menuIcon} />
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography variant="h5" marginBottom={".3125rem"}>
                          {item.jsonKey
                            ? t(item.jsonKey)
                            : item.menuDisplayName}
                        </Typography>
                      }
                    />
                  </ListItem>
                  <Divider />
                </React.Fragment>
              ))
          ) : (
            <></>
          )}
        </Box>
        {showRaiseABug && (
          <RaiseABug
            showRaiseABug={showRaiseABug}
            handleComponent={setShowRaiseABug}
          />
        )}
        {open && <CallUsPopUp open={open} handleOpen={setOpen} />}
        {emailPopupOpen && (
          <EmailUsPopUp open={emailPopupOpen} handleOpen={setEmailPopupOpen} />
        )}
        {showChatWithUs && (
          <CustomChatWithUs
            showIframe={showChatWithUs}
            onClose={handleCloseChat}
            functionalityCode="D"
            LobId="25"
          />
        )}
      </CommonMenuListPage>
    </>
  );
};

export default HelpAndSupport;
